import { render, staticRenderFns } from "./_fc.vue?vue&type=template&id=454685d8&lang=pug&"
import script from "./_fc.vue?vue&type=script&lang=js&"
export * from "./_fc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports